module.exports = __webpack_public_path__ + "img/tijiao.0998a3ba.png";